import {
  MENSWEAR_SHOPPING_PREFERENCE,
  WOMENSWEAR_SHOPPING_PREFERENCE,
  MENSWEAR_SHOPPING_PREFERENCE_STRING,
  WOMENSWEAR_SHOPPING_PREFERENCE_STRING,
} from '../../common/constants';

export const getGenderStringFromCode = (code: string): string => {
  switch (code) {
    case MENSWEAR_SHOPPING_PREFERENCE:
      return MENSWEAR_SHOPPING_PREFERENCE_STRING;
    case WOMENSWEAR_SHOPPING_PREFERENCE:
      return WOMENSWEAR_SHOPPING_PREFERENCE_STRING;
    default:
      return '';
  }
};
